"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function File() {
    return (react_1.default.createElement("svg", { width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: "56", height: "56" }),
            react_1.default.createElement("path", { fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2", d: "M33.4418314,2.99978065 L47,16.5560321 L47,53 L9,53 L9,2.99999138 L33.4418314,2.99978065 Z" }),
            react_1.default.createElement("polygon", { fill: "#FFF", points: "33 4 46 17 33 17" }),
            react_1.default.createElement("polyline", { stroke: "#BFBFBF", strokeWidth: "2", points: "46 18 32 18 32 4" }))));
}
exports.default = File;
//# sourceMappingURL=File.js.map